import i18n from "i18next";

/**
 * i18n-first cell rendering helper.
 *
 * Backend exposes `<field>Display` computed_fields for any column whose raw
 * value (bool/int/enum-string) needs humanization. Those backend strings are
 * the source of truth for server-side CSV exports (no i18n context). The UI
 * should prefer the i18n key — so localization and CRM-129 per-account term
 * overrides keep working — and fall back to the backend display string when
 * the key is missing, instead of leaking raw `True`/`1`/`not_booked` values.
 */
export const tWithFallback = (
  key: string,
  fallback: string | null | undefined
): string => (i18n.exists(key) ? i18n.t(key) : (fallback ?? ""));
